var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(-1113 -1513)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1113 1513)",
    fill: "#83b797"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_317735_career_linkedin_icon",
    "data-name": "317735_career_linkedin_icon",
    transform: "translate(1126.171 1524.416)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    width: 3.549,
    height: 11.534,
    transform: "translate(0 4.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M17.358,9c-1.957,0-2.5.642-2.935,1.467V9H11V20.246h3.423V13.89c0-.978,0-1.956,1.711-1.956s1.711.978,1.711,1.956v6.356h3.423V13.89C21.268,10.956,20.779,9,17.358,9Z",
    transform: "translate(-5.622 -4.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 1.775,
    cy: 1.775,
    r: 1.775,
    transform: "translate(0 -0.416)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ac0851f0961e0a323258fb5dcf35112b.svg";
export { ForwardRef as ReactComponent };